import { ref, Ref } from '@vue/composition-api';
import { InterestBehaviorData, AdgroupFormData, TargetingKeywordsSearchStatus } from '@tt4b/ttam-enums';
import { useBehaviorData } from './../../../../hooks/creation/adgroup/useBehavior/index';
// 用来显示hashtag
const displayPreOfflineHashtags = ref<InterestBehaviorData[]>([]);
// 用来存储初始值的hashtag
let preOfflineHashtagsSnapshot: InterestBehaviorData[] = [];

export function useHashtagPreOnline(options: { adgroupData: Ref<AdgroupFormData>; ctx?: any }) {
  const { adgroupData, ctx } = options;
  const showRemovePreOfflineTagsDialog = ref(false);
  const { hashtagCategories, hashtagData, getChangedBehaviorData } = useBehaviorData({ adgroupData });
  // 移除所有将下线的hashtag
  function removeAllPreOfflineTags() {
    const _displayPreOfflineHashtags = new Set(displayPreOfflineHashtags.value.map(tag => tag.tag_id));
    const categories = hashtagCategories.value.filter(id => !_displayPreOfflineHashtags.has(id));
    const data = getChangedBehaviorData({ ...hashtagData.value, categories }, 'hashtag');
    displayPreOfflineHashtags.value = [];
    preOfflineHashtagsSnapshot = [];
    ctx && ctx.emit('change', data);
  }
  //  确认删除下线的hashtag
  function removePreOfflineTags() {
    const _displayPreOfflineHashtags = new Set(displayPreOfflineHashtags.value.map(tag => tag.tag_id));
    const categories = hashtagCategories.value.filter(id => !_displayPreOfflineHashtags.has(id));
    const data = getChangedBehaviorData({ ...hashtagData.value, categories }, 'hashtag');
    preOfflineHashtagsSnapshot = preOfflineHashtagsSnapshot.filter(tag => !_displayPreOfflineHashtags.has(tag.tag_id));
    displayPreOfflineHashtags.value = [];
    showRemovePreOfflineTagsDialog.value = false;
    ctx && ctx.emit('change', data);
  }
  // 关闭弹窗
  function onRemovePreOfflineTagsDialogClose() {
    showRemovePreOfflineTagsDialog.value = false;
    displayPreOfflineHashtags.value = [...preOfflineHashtagsSnapshot];
  }
  // 删除其中一个
  function closeOnePreOfflineTag(item) {
    displayPreOfflineHashtags.value = displayPreOfflineHashtags.value.filter(tag => tag.tag_id !== item.tag_id);
  }
  // 处理preonline的tag
  function handlePreOfflineHashTag(list) {
    displayPreOfflineHashtags.value = list.filter(item => item.status === TargetingKeywordsSearchStatus.PRE_OFFLINE);
    preOfflineHashtagsSnapshot = [...displayPreOfflineHashtags.value];
  }

  return {
    displayPreOfflineHashtags,
    removePreOfflineTags,
    showRemovePreOfflineTagsDialog,
    onRemovePreOfflineTagsDialogClose,
    closeOnePreOfflineTag,
    removeAllPreOfflineTags,
    handlePreOfflineHashTag,
  };
}
